import { render, staticRenderFns } from "./RouteMetaAdmin.vue?vue&type=template&id=3a05e572&scoped=true"
import script from "./RouteMetaAdmin.vue?vue&type=script&lang=js"
export * from "./RouteMetaAdmin.vue?vue&type=script&lang=js"
import style0 from "./RouteMetaAdmin.vue?vue&type=style&index=0&id=3a05e572&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a05e572",
  null
  
)

export default component.exports